import { datadogRum } from '@datadog/browser-rum';
import { config } from '@ibk/shared-config';
import packageJson from '../../package.json';
export const initDatadog = () => {
    const dataDogBaseConfig = {
        applicationId: config.datadogApplicationId,
        clientToken: config.datadogClientToken,
        site: config.datadogSite,
        env: config.datadogEnv,
        service: config.datadogService,
        allowedTracingUrls: config.datadogAllowedTracingUrls
            ? config.datadogAllowedTracingUrls.split(',').map(url => url.trim())
            : undefined,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        version: packageJson.version,
    };
    datadogRum.init(dataDogBaseConfig);
};
export const setDatadogUser = (personId, partyId) => {
    if (personId) {
        datadogRum.setUserProperty('personId', personId);
    }
    if (partyId) {
        datadogRum.setUser({
            id: partyId,
            partyId
        });
    }
};
export const clearDatadogUser = () => {
    datadogRum.clearUser();
};
